module.exports = __webpack_public_path__ + "static/img/3-11.89bba7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-11.jpg
// module id = MeG4
// module chunks = 1